import {environment} from '@env/environment';
import {Injectable} from '@angular/core';
import {AbstractPaginatedService} from '@app/shared/interfaces/service-classes';
import {ZonaModel} from '@shared/models/zona.model';
import {Observable} from 'rxjs';

@Injectable()
export class ZonasUserService extends AbstractPaginatedService<ZonaModel, undefined> {
  buildUrlBase(): string {
    return `${environment.api.admin.zonas.user}`;
  }

  getAll(): Observable<ZonaModel[]> {
    return this.http.get<ZonaModel[]>(this.buildUrlBase() + '/all');
  }
}
